export default __webpack_public_path__ + "static/media/green_tickmaak.b9f8e3e0.svg";